import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';

export const useIsDashboardDurationApplied = () => {
  return useQuantifyStore(({ visual }) => !!visual.dashboardFilters?.duration);
};
